




































import { Component, Prop, Vue ,Watch} from 'vue-property-decorator';

@Component
export default class spikeItem extends Vue {
    get goodsDesc(){
      return this.$store.getters["collationData/getGoodsDetailData"];
    }
}
